module.exports = "/_next/static/images/67c280abfab654f1e47ea4654b89c831-right-side-mobile.jpg.webp";